<div class="modal-header flex flex-row justify-between items-center">
  <div class="flex flex-row justify-between items-center">
    <div class="m-r-30">
      <h1>Select Form(s)</h1>
    </div>
    <div>
      <mat-radio-group *ngIf="filingExportOptions"
                       class="flex flex-row"
                       (change)="onExportOptionsSelectionChange($event)"
                       aria-label="Select an option">

        <mat-radio-button class="m-r-10" *ngFor="let exportOption of filingExportOptions.ExportOptions"
                          [value]="exportOption"
                          matTooltip="{{exportOption.MetaData.Tooltip?exportOption.MetaData.Tooltip:''}}"
                          [disabled]="!exportOption.HasImplementation"
                          [checked]="exportOption.DownloadType === selectedExportOptions.DownloadType">

          {{exportOption.Header}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <mat-dialog-actions>
    <button class="material-icons" mat-dialog-close
            particleAnalytics
            analyticsCategory="add-task-diaolog"
            analyticsAction="close-btn">close
    </button>
  </mat-dialog-actions>

</div>
<mat-dialog-content>
  <div class="flex flex-col full-grow-no-shrink-no-basis">
    <div *ngIf="message!==null" class="notification-message-container m-0 m-b-10">
      {{message}}
    </div>
    <div class="full-grow-no-shrink-no-basis" *ngIf="apiKey!==null">
      <particle-entity-selector [filterId]="filterId"
                                [filterTemplateId]="filterTemplateId"
                                [invalidateSubject]="invalidateSubject"
                                [endpointName]="apiKey"
                                [leftSourceType]="leftSourceType"
                                [input]="input"
                                (rightElementsCount)="transferCount($event)"
      >
      </particle-entity-selector>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
  <button class="common-button" (click)="onCancel()"
          analyticsCategory=""
          analyticsAction="" mat-button="" particleAnalytics="">
    Cancel
  </button>
  <button class="action-button" (click)="onOkClicked()"
          analyticsCategory=""
          analyticsAction="" mat-button="" particleAnalytics="">
    Next
  </button>


</mat-dialog-actions>






